import { FC } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { ThemeProvider as ScThemeProvider } from 'styled-components';

import { SettingsSelectors } from '@store';
import { useAppSelector } from '@hooks';
import { getTheme } from '@themes';

export const Themable: FC = ({ children }) => {
  const currentTheme = useAppSelector(SettingsSelectors.selectTheme);
  const theme = getTheme(currentTheme);

  return (
    <MuiThemeProvider theme={theme}>
      <ScThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ScThemeProvider>
    </MuiThemeProvider>
  );
};
